import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DpPdfPreviewStore {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

export const useDpPdfPreviewStore = create<DpPdfPreviewStore>()(
  persist(
    (set) => ({
      isOpen: false,
      toggle: () => set((s) => ({ isOpen: !s.isOpen })),
      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),
    }),
    { name: 'dp-pdf-preview-panel', version: 1 },
  ),
);
